<style lang="scss" scoped>
@import "./login.scss";
</style>
<style lang="scss">
.auth {
    &-login &-input input {
        margin-top: 15px;
        background-color: transparent;
        border: none;
        border-bottom: 2px solid #fff;
        box-shadow: none !important;
        outline: none !important;
        border-radius: 0;
        font-weight: bold;
        color: #fff;
        font-size: 30px;
        text-align: center;
        &::placeholder {
            // color: #fff;
            color: #686868;
            font-size: 14px;
            font-weight: normal;
        }
    }
}
</style>
<template>
    <div class="auth-login" @keyup.enter="submitAuthLogin">
    <!-- <div class="auth-login"> -->
        <h3 class="login-title">{{$t('port.login.mfa_verfer', { defaultValue: '通过验证器验证' })}}</h3>
        <div class="tip">{{$t('port.login.input_mfa_verf_code', { defaultValue: '请输入验证器中的验证码' })}}</div>
        <Form ref="authForm" class="auth-form" :model="authForm" :rules="rules" >
            <FormItem class="login-item" prop="vCode">
                <Input class="auth-input" v-model="authForm.vCode" :placeholder="$t('port.login.input_verf_code', { defaultValue: '输入验证码' })"></Input>
            </FormItem>
            <div class="button-content clearfix">
                <Button type="primary" class="pull-right" @click="submitAuthLogin">
                    {{ $t("port.login.login") }}&nbsp;
                    <Icon type="md-arrow-forward" />
                </Button>
            </div>
            <a v-if="hasSwitch" style="display: block; margin: 10px 0;" @click="changeValidType">{{$t('port.login.change_verf_type', { defaultValue: '使用其他方式验证' })}}</a>
        </Form>
    </div>
</template>

<script>
export default {
    props: ['loginCheckList'],
    data() {
        return {
            authForm: {
                vCode: '',
            },
            hasSwitch: false
        };
    },
    mounted () {
        if (this.loginCheckList.length > 0) {
            this.hasSwitch = true
        }
    },
    methods: {
        /**
         * 提交
         */
        async submitAuthLogin () {
            await this.$refs.authForm.validate(valid => {
                if (valid) {
                    this.$emit('on-commit', this.authForm)
                }
            })
            return false;
        },
        /**
         * 切换验证方式
         */
        changeValidType () {
            this.$emit('on-switch')
        },
    },
    computed: {
        rules() {
            return {
                vCode: [
                    {
                        required: true,
                        message: this.$t("global.common.fill_required", {
                            defaultValue: "该信息不能为空,请填写",
                        }),
                    },
                    {
                        trigger: "blur",
                        validator: (rule, value = "", callback) => {
                            if (/^[0-9]{6}$/.test(value)) {
                                callback();
                            } else {
                                callback(new Error(this.$t('port.login.input_six_number', { defaultValue: "请输入6位数字验证码" })));
                            }
                        },
                    },
                ],
            };
        },
    },
};
</script>